import React, { Component } from "react";
import { connect } from "react-redux";
// Actions
import { batchReviseItems, createManualDonation, deleteItem, getHistory, getItems } from "../../redux/actions/Marketplace";
// Components
import { FoodWeightReviewTable } from "../organisms/Table";
import { Button } from "../atoms/Button";
// Constants
import i18nstring, { strings } from "../../i18n";

// Themes
import "./PageStyles.scss";
import { foodWeightHeaders } from "../../model/Table";
import SelfService from "./SelfService";
import { getPastDateFromMonths } from "../../utils";
import { Colors } from "../../constants/Styles";
import { PastDonationModal } from "../organisms/Modal";
import { Dropdown, DropdownDivider, DropdownHeader, DropdownItem, DropdownMenu } from "semantic-ui-react";
import api from "../../api";
import ConfirmationPopup from "../atoms/ConfirmationPopup";
import { getUserGroup } from "../../redux/actions/User";
import { Roles } from "../../Shared/Constants/Roles";
import { addItem } from "../../transforms/ItemTransforms";

class FoodWeightReview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      updatedWeights: [],
      updatedItemsObj: {},
      pastDonationMonths: 6,
      toggleModal: false,
      openDropdown: false,
      modalOpen: false,
      selectedOption: null,
      addresses: [],
      pastAfterDateTime: getPastDateFromMonths(6),  
      showConfirmationModal: false,
      selectedItem: null,
    };
  }

  componentDidMount() {
    if (!this.props.itemsFetched) {
      this.props.getHistoryItems(this.state.pastAfterDateTime);
    }
    this.props.attemptGetUsers(Roles.PRODUCER);
    this.props.attemptGetUsers(Roles.COURIER);
    this.getDonationAddresses()

    const tempWeights = {};
    this.props.items.forEach(item => {
      const { weight, pickUpWeight } = item;
      const latestWeight = pickUpWeight ? pickUpWeight : weight;
      tempWeights[item.id] = latestWeight;
    });
    this.setState({ updatedItemsObj: tempWeights });
  }

  getDonationAddresses = () => {
    api.address.getAddresses().then(addresses => {
      this.setState({addresses: addresses?.data || []})
    });
  }

  refreshItemsAndHistory = () => {
    this.props.getHistoryItems(this.state.pastAfterDateTime);
    this.setState({ updatedWeights: {} });
  };

  handleUpdateWeight = item => {
    const { updatedWeights, updatedItemsObj } = this.state;
    const { id, updatedWeight } = item;
    const tempObj = {
      ...updatedWeights
    };

    if (parseFloat(updatedItemsObj[id]) === parseFloat(updatedWeight)) {
      delete tempObj[id];
    } else if (parseFloat(updatedWeight) >= 0) {
      tempObj[id] = parseFloat(updatedWeight);
    }
    this.setState({ updatedWeights: tempObj });
  };

  sendWeightUpdates = () => {
    const { updatedWeights } = this.state;

    const itemsToSend = this.props.items
      .filter(item => updatedWeights[item.id] !== undefined)
      .map(item => ({ id: item.id, pickupWeight: updatedWeights[item.id] }));

    this.props.attemptChangeWeights(itemsToSend);
    this.setState({ updatedWeights: {} });
  };

  getDonations = () => {
    this.refreshItemsAndHistory();
    this.props.attemptGetItems();
  }

  closeDonationModal = () => {
    this.setState({ toggleModal: {}, selectedOption: null });
  };

    handleChange = (value) => {
      this.setState({
        selectedOption: value,
        toggleModal: true,
        openDropdown: false,
      })
  };

  handleCloseModal = () => {
     this.setState({
        selectedOption: null,
        toggleModal: false,
      })
  };

  createDonation = (data) => {
    this.props.attemptCreateManualDonation(data);
  };

  handleConfirmationClick = () => {
    if (this.state.selectedItem === null)
      return;
    this.props.attemptDeleteDonation(this.state.selectedItem);
  }


  render() {
    const { updatedWeights } = this.state;

    const areWeightsUpdating = Object.keys(updatedWeights).length > 0;

    return (
      <div className="main_container_section donations_container">
        <div className="donations_refresh_container">
          <div className="hover-dropdown-wrapper">
            <Dropdown
              text={i18nstring(strings.RECORD_PAST_DONATION)}
              className="add-donation-dropdown"
            >
              <DropdownMenu>
                <DropdownItem onClick={e => this.handleChange("linked")}>
                  {i18nstring(strings.LINKED_DONATION)}
                </DropdownItem>
                <DropdownItem onClick={e => this.handleChange("unlinked")}>
                  {i18nstring(strings.UNLINKED_DONATION)}
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          <Button onClick={this.getDonations}>
            {i18nstring(strings.REFRESH)}
          </Button>
        </div>
        <SelfService />
        <div className="instructions_button_container">
          <div className="refresh_container">
            {areWeightsUpdating ? (
              <div className="update_weights_container">
                <Button onClick={this.sendWeightUpdates}>
                  {i18nstring(strings.UPDATE_WEIGHTS)}
                </Button>
              </div>
            ) : null}
          </div>
        </div>
        <div className="main_container_table">
          <div className="main_container_table_header">
            <div className="table_title">
              {i18nstring(strings.PAST_DONATIONS)}
            </div>
          </div>
          <FoodWeightReviewTable
            approvalStatus={true}
            headers={foodWeightHeaders}
            items={this.props.items}
            updatedWeights={updatedWeights}
            handleUpdateWeights={this.handleUpdateWeight}
            selectedOption={this.state.selectedOption}
            deleteItem={(itemId)=> {
              this.setState({showConfirmationModal: true, selectedItem: itemId})
            }}
          />
        </div>
        {this.state.toggleModal === true && (
          <PastDonationModal
            toggleModal={this.state.toggleModal}
            setToggle={this.closeDonationModal}
            selectedOption={this.state.selectedOption}
            gardeners={this.props.gardeners}
            couriers={this.props.couriers}
            subscriptions={this.props.subscriptions}
            addressesList={this.state.addresses}
            createDonation={this.createDonation}
          />
        )}
        {this.state.showConfirmationModal && (
          <ConfirmationPopup
            title={i18nstring(strings.CONFIRMATION)}
            message={i18nstring(strings.DELETE_DONATION_CONFIRMATION_MESSAGE)}
            primaryButtonText={i18nstring(strings.CONFIRM)}
            onPrimaryButtonClicked={this.handleConfirmationClick}
            open={this.state.showConfirmationModal}
            setOpen={(value) => this.setState({showConfirmationModal : value})}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  items: state.marketplace.history,
  itemsFetched: state.marketplace.historyFetched,
  gardeners: state.user.gardeners,
  couriers: state.user.couriers,
  subscriptions: state.subscription.subscriptions,
  loadedAddresses: state.timeWindow.loadedAddresses,

});

const mapDispatchToProps = dispatch => {
  return {
    attemptGetItems: () => dispatch(getItems(undefined,true, true)),
    attemptChangeWeights: newItems => dispatch(batchReviseItems(newItems)),
    getHistoryItems: (deliveredDate) => dispatch(getHistory(null, deliveredDate)),
    attemptDeleteDonation: (id) => dispatch(deleteItem(id)),
    attemptGetUsers: userGroup => dispatch(getUserGroup(userGroup)),
    attemptCreateManualDonation: (data) => dispatch(createManualDonation(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FoodWeightReview);
